// extracted by css-extract-rspack-plugin
export default {"activator":"MobileEllipsisText-module__activator--fFwU8"};